import { render } from "./TrazSood.vue?vue&type=template&id=78818c4c&scoped=true"
import script from "./TrazSood.vue?vue&type=script&lang=js"
export * from "./TrazSood.vue?vue&type=script&lang=js"

import "./TrazSood.vue?vue&type=style&index=0&id=78818c4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78818c4c"]])

export default __exports__